export const BOOKING_CLIENT_SETTINGS_QUERY_KEY = 'bookingClientSettings'
export const ANONYMOUSLY_BOOKING_CLIENT_SETTINGS_QUERY_KEY = 'anonymouslyBookingClientSettings'
